import React from "react";

const ViewUser = ({ selectedRecord }) => {

  return (
    <div className="flex flex-col gap-[25px]">
      <p className="text-[24px] smtext-[40px] text-center font-normal text-black leading-[32px] sm:leading-[48px] px-[50px]">
        User Details
      </p>
      <div className="flex  w-full gap-[16px]  md:flex-row flex-col">
        <p className="text-[16px] font-semibold w-[120px]">Name</p>
        <p>{selectedRecord?.name}</p>
      </div>
      <div className="flex  w-full gap-[16px]  md:flex-row flex-col">
        <p className="text-[16px] font-semibold w-[120px]">Your Age</p>
        <p>{selectedRecord?.age}</p>
      </div>
      <div className="flex  w-full gap-[16px]  md:flex-row flex-col">
        <p className="text-[16px] font-semibold w-[120px]">Email Address</p>
        <p>{selectedRecord?.email}</p>
      </div>
      <div className="flex  w-full gap-[16px]  md:flex-row flex-col">
        <p className="text-[16px] font-semibold w-[120px]">Phone Number</p>
        <p>{selectedRecord?.phone_number}</p>
      </div>
      <div className="flex  w-full gap-[16px]  md:flex-row flex-col">
        <p className="text-[16px] font-semibold w-[120px]">Description</p>
        <p>{selectedRecord?.description}</p>
      </div>
    </div>
  );
};

export default ViewUser;
